// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewCompanyReportComp from '../../components/Company/ViewCompanyReport/ViewCompanyReport';
// Type imports:
import { ICompanyReportViewModel } from '../../types/CompanyTypes';

const ViewCompanyReport: React.FC<ICompanyReportViewModel> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Innsleginn ársreikningur'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                noAd
                component={
                    <ViewCompanyReportComp
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                    />
                }
                showRecentReports
            />
        </Entrypoint>
    );
}

export default ViewCompanyReport;